import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FaqSectionComponent } from '../../shared/components/faq-section/faq-section.component';
import { I18nPipe } from '../../shared/pipes/i18n.pipe';

@Component({
  selector: 'umkt-help-center',
  standalone: true,
  imports: [
    CommonModule,
    FaqSectionComponent,
    I18nPipe
  ],
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss']
})
export class HelpCenterComponent {}
